import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiService} from "@amlCore/services";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CountryRiskModel} from "../../model/countryRisk.model";

@Injectable({ providedIn: "root" })
export class CountryRiskService {
  constructor(private apiService: ApiService,
              private fb: FormBuilder) {
  }


  /**
   * Получить список
   */
  getList(params: any): Observable<Array<CountryRiskModel>> {
    return this.apiService.get("/api/v1/qref/countryrisk", params, 'id');
  }

  /**
   * Получение записи по id
   * @param id - id
   */
  getCountryRiskById(id: string): Observable<CountryRiskModel> {
    return this.apiService.get(`/api/v1/qref/countryrisk/${id}`);
  }

  /**
   * Создание/обновление
   * @param data - данные
   */
  saveCountryRisk(data: CountryRiskModel): Observable<any> {
    return this.apiService.post('/api/v1/qref/countryrisk', data);
  }

  getForm(): FormGroup {
    return this.fb.group({
      id: null,
      cause: [null, Validators.required],
      countries: [[], Validators.required]
    });
  }
}
